import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  CreatePatientRequest,
  SearchPatientRequest
} from '../models/patient';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PatientService {

  private apiUrl = environment.apiUrl + '/patients';

  constructor(private http: HttpClient) { }

  create(
    request: CreatePatientRequest
  ): Observable<any> {

    return this.http.post(
      this.apiUrl,
      request
    );
  }

  checkDuplicate(request: any) {

    return this.http.post<any>(
      `${this.apiUrl}/check-duplicate`,
      request
    );
  }

  getById(id: number) {

    return this.http.get<any>(
      `${this.apiUrl}/${id}`
    );
  }

  getLatest() {

    return this.http.get<any[]>(
      `${this.apiUrl}/latest`
    );
  }

  update(id: number, request: any) {

    return this.http.put<any>(
      `${this.apiUrl}/${id}`,
      request
    );
  }

  delete(id: number): Observable<any> {

    return this.http.delete<any>(
      `${this.apiUrl}/${id}`
    );
  }

  search(request: SearchPatientRequest) {

    const payload = this.normalizeSearchRequest(request);

    return this.http.post<any[]>(
      `${this.apiUrl}/search`,
      payload
    );
  }

  getLatestPaged(
    page: number,
    pageSize: number
  ) {

    return this.http.get<any>(
      `${this.apiUrl}/latest-paged?page=${page}&pageSize=${pageSize}`
    );
  }

  private normalizeSearchRequest(request: SearchPatientRequest): SearchPatientRequest {

    return {
      ...request,
      nominativo: this.normalizeString(request?.nominativo),
      dataNascita: this.normalizeDateLike(request?.dataNascita),
      genere: this.normalizeString(request?.genere),
      etaDa: this.normalizeNumber(request?.etaDa),
      etaA: this.normalizeNumber(request?.etaA),
      dataInserimentoDa: this.normalizeDateLike(request?.dataInserimentoDa),
      dataInserimentoA: this.normalizeDateLike(request?.dataInserimentoA),
      classeSfge: this.normalizeString(request?.classeSfge)
    };
  }

  private normalizeString(value: string | null | undefined): string | null {

    if (value === null || value === undefined) {
      return null;
    }

    const trimmed = value.toString().trim();

    return trimmed.length > 0 ? trimmed : null;
  }

  private normalizeDateLike(value: string | null | undefined): string | null {

    if (value === null || value === undefined) {
      return null;
    }

    const trimmed = value.toString().trim();

    return trimmed.length > 0 ? trimmed : null;
  }

  private normalizeNumber(value: number | null | undefined): number | null {

    if (value === null || value === undefined) {
      return null;
    }

    const parsed = Number(value);

    return Number.isFinite(parsed) ? parsed : null;
  }

}